import { useFeatureFlagsStore } from '@/stores/useFeatureFlags';
import { useUserDetailsStore } from '@/stores/useUserDetails';
import { featureFlagSlugs } from '@/constants/featureFlagSlugs';
import { authExemptRoutes } from '@/constants/authRoutes';

export default defineNuxtRouteMiddleware(async (to) => {
  /**
   * This check prevents `/authenticate` from being called twice
   */
  if (
    to.fullPath === '/check-email' ||
    authExemptRoutes.includes(to.fullPath) ||
    to.query?.code ||
    to.hash
  ) {
    return;
  }

  const featureFlagsStore = useFeatureFlagsStore();
  const userDetailsStore = useUserDetailsStore();

  const isMagicLinkLoginEnabled = featureFlagsStore.getByFlagName(
    featureFlagSlugs.transportMagicLinkLogin,
  );

  if (isMagicLinkLoginEnabled) {
    await userDetailsStore.getAuthenticatedUserDetails();
  } else {
    await userDetailsStore.getUserDetails();
  }
});
